import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FormControl} from '@angular/forms';
import {MatCheckboxChange} from '@angular/material/checkbox';
import {REIRedistributionStatus} from 'smag-commons/dto/eco/community';

export interface ReiResponse {
  useReiVal: boolean;
  year: number;
}

@Component({
  selector: 'app-set-rei',
  templateUrl: './set-rei.component.html',
  styleUrls: ['./set-rei.component.scss']
})
export class SetReiComponent implements OnInit {

  useRei: FormControl = new FormControl(false, []);
  isIndeterminate = false;

  @Input() massiveConfig: boolean;
  @Input() year: number;
  @Input() inputRei: boolean;
  @Input() inputReiStatus: REIRedistributionStatus;
  @Output() reiResponse: EventEmitter<ReiResponse> = new EventEmitter<ReiResponse>();
  @Output() valid: EventEmitter<boolean> = new EventEmitter<boolean>();

  constructor() {
  }

  ngOnInit(): void {
    if (this.inputRei) {
      this.useRei.setValue(this.inputRei);
    }
    if (this.inputReiStatus) {
      switch (this.inputReiStatus) {
        case REIRedistributionStatus.REDISTRIBUTED:
          this.useRei.setValue(true);
          break;
        case REIRedistributionStatus.NOT_REDISTRIBUTED:
          this.useRei.setValue(false);
          break;
        case REIRedistributionStatus.MIXED:
          this.isIndeterminate = true;
          break;
      }
    }
    const rei: ReiResponse = {
      useReiVal: this.isIndeterminate ? null : this.useRei.value,
      year: this.year
    };
    this.reiResponse.next(rei);
    this.valid.next(this.useRei.valid);
  }

  manageChanges($event: MatCheckboxChange) {
    const rei: ReiResponse = {
      useReiVal: $event.checked,
      year: this.year
    };
    this.reiResponse.next(rei);
    this.valid.next(this.useRei.valid);
  }

}
